import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, ToggleButton } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Icon from '../../Icon';
import { useGetAppAdminQuery, useUpdateAppAdminMutation } from '../../../api/appAdminApiSlice';
import Select from  '../../forms/inputs/Select';
import BoolSelect from  '../../forms/inputs/BoolSelect';
import FormGroup from  '../../forms/FormGroup';
import { useForm, Yup } from '../../forms/form'
import get from 'lodash/get';
import versionCompare from '../../../services/versionCompare';

const EditAppModal = ({appId, show, onClose}) => {
  const { t } = useTranslation();
  const { data: app={}, isSuccess, isLoading, isError, retry } = useGetAppAdminQuery(appId)
  const [update] = useUpdateAppAdminMutation();
  const initialValues = {
    tracked: false,
    cmp_approved: false,
    cmp_approved_and_above: false,
  }
  const validationSchema = Yup.object().shape({
    tracked: Yup.boolean(),
    cmp_approved: Yup.boolean(),
    cmp_approved_and_above: Yup.boolean(),
  })

  const { formData, setFormData, getInputProps, formProps, submitButtonProps } = useForm({
    defaultObject: app,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (data) => {
      update({...app, ...data}).unwrap().then(onClose)
    },
  });
  const ColoredTick = ({value}) => {
    if (value) {
      return <Icon icon={"checkCircle"} style={{color: "green"}}/>
    } else {
      return <Icon icon={"crossCircle"} style={{color: "red"}}/>
    }
  }
  const cmpApprovalVersionOptions = (app) => {
    const appVersionCmpApproval = get( app, "app_versions_cmp_approval", [] )
    return [...appVersionCmpApproval].sort((a, b) => versionCompare(b?.app_version, a?.app_version)).map((v) => ({value: v.app_version, label: (<>{v.app_version} <ColoredTick value={v.cmp_approved}/></>)}))
  }

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
        {t("edit")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form {...formProps}>
          <Form.Row>
            <FormGroup as={Col} md={12} lg={12} {...getInputProps("tracked")} label={t('app.tracked')}>
              <BoolSelect/>
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col} md={12} lg={12} {...getInputProps("cmp_approved")} label={t('app.cmp_approved')}>
              <BoolSelect/>
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col} md={12} lg={12} {...getInputProps("app_version")} label={t('app.cmp_approved_app_version')}>
              <Select options={cmpApprovalVersionOptions(app)} isLoading={isLoading}/>
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col} md={12} lg={12} {...getInputProps("cmp_approved_and_above")} label={t('app.cmp_approved_and_above')}>
              <BoolSelect/>
          </FormGroup>
          </Form.Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button key="submit" type="submit" variant="primary" {...submitButtonProps} >
          <Icon icon='save' text={t("save")}/>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditAppModal;
